import { render } from "./BloqueDosSeciones.vue?vue&type=template&id=7ea70521"
import script from "./BloqueDosSeciones.vue?vue&type=script&lang=js"
export * from "./BloqueDosSeciones.vue?vue&type=script&lang=js"

import exportComponent from "/home/desarrollo/Escritorio/web-bayer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__